/**
 * Constructs a GraphQL set representation from a list of strings or numbers.
 *
 * @param {(string | number)[]} list - The list of strings or numbers.
 * @returns {string | null} - The constructed GraphQL set string or null if the list is empty.
 */
export const getGraphQLSet = (list: (string | number)[]) => {
  if (list?.length === 0 || !list) {
    return null;
  }
  const joined = list
    .filter((x) => (typeof x === 'string' && x.length > 0) || typeof x === 'number')
    .join();

  if (joined.length === 0) {
    return null;
  }
  return `{${joined}}`;
};

/**
 * Parses a filter object and returns its corresponding GraphQL representation.
 *
 * @param {Object} filter - The filter object.
 * @returns {any} - The parsed filter value in GraphQL format.
 */
export const parseFilter = (filter) => {
  const value = filter[filter.type];
  // compicated structures defined here
  if (filter.type === 'deskIds' || filter.type === 'brainIds' || filter.type === 'agentIds') {
    return getGraphQLSet(value.map((val) => val.value));
  } else if (filter.type === 'insightFilters') {
    // insight filters are passed as JSON directly
    return value;
  } else if (typeof value === 'object') {
    // filter value type of array
    return getGraphQLSet(value);
  } else if (filter.type === 'maxConfidence') {
    return value / 100;
  } else {
    return typeof value === 'string' ? value.trim() : value;
  }
};
